import { render, staticRenderFns } from "./HelpdeskGroupsSelect.vue?vue&type=template&id=60ef8f4e"
import script from "./HelpdeskGroupsSelect.vue?vue&type=script&lang=js"
export * from "./HelpdeskGroupsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports